'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var utils = require('@chakra-ui/utils');
var react = require('@chakra-ui/react');
var React = require('react');
var Logo = require('../Logo/Logo.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["showLogo", "maxWidth", "maxW", "logo", "className", "children", "footer", "padding"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * Minimal layout
 *
 * A page layout consisting of our default background, logo, and a constrained
 * container, centered in both axis.
 */
var MinimalLayout = function MinimalLayout(props) {
  var _props$showLogo = props.showLogo,
    showLogo = _props$showLogo === void 0 ? true : _props$showLogo,
    maxWidthProp = props.maxWidth,
    maxWProp = props.maxW,
    _props$logo = props.logo,
    logo = _props$logo === void 0 ? /*#__PURE__*/React__default["default"].createElement(Logo.Logo, null) : _props$logo,
    className = props.className,
    children = props.children,
    footer = props.footer,
    _props$padding = props.padding,
    padding = _props$padding === void 0 ? 6 : _props$padding,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var maxWidth = maxWProp || maxWidthProp || 365;
  var wrapperStyles = {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    minH: '100vh',
    pt: 16,
    bgGradient: 'linear(to-t, #f0f2fa, #f5f7fc 100%)'
  };
  var containerStyles = _defineProperty__default["default"]({
    width: '100%',
    mx: 'auto',
    maxWidth: maxWidth,
    px: padding
  }, "@media (min-width: ".concat(maxWidth, "px)"), {
    px: 0
  });
  var footerStyles = {
    px: padding,
    pb: padding
  };
  var logoContainerStyles = _objectSpread({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }, containerStyles);
  var logoComponent = /*#__PURE__*/React__default["default"].cloneElement(logo, {
    alt: 'Logo'
  });
  var footerComponent = footer && /*#__PURE__*/React__default["default"].cloneElement(footer);
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    className: utils.cx('chakra-minimal-layout', className),
    __css: wrapperStyles
  }, rest), showLogo && /*#__PURE__*/React__default["default"].createElement(react.chakra.div, {
    __css: logoContainerStyles
  }, logoComponent), /*#__PURE__*/React__default["default"].createElement(react.chakra.div, {
    __css: _objectSpread(_objectSpread({}, containerStyles), {}, {
      m: 'auto'
    })
  }, children), footer && /*#__PURE__*/React__default["default"].createElement(react.chakra.div, {
    __css: footerStyles
  }, footerComponent));
};
MinimalLayout.displayName = 'MinimalLayout';
exports.MinimalLayout = MinimalLayout;